import { render, staticRenderFns } from "./ProjectEditorHeaderDocInfo.vue?vue&type=template&id=30a57049"
import script from "./ProjectEditorHeaderDocInfo.vue?vue&type=script&lang=ts"
export * from "./ProjectEditorHeaderDocInfo.vue?vue&type=script&lang=ts"
import style0 from "./ProjectEditorHeaderDocInfo.vue?vue&type=style&index=0&id=30a57049&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports